import {
  REQUEST_GENERATE_REPORT,
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_FAILED,
  GENERATE_REPORT_IN_PROGRESS
} from '../actions/types';

export const taskReducers = (
  state = {
    loading: true,
    taskStatus:null,
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_GENERATE_REPORT:
      return { ...state, loading: true, taskStatus: null };
    case GENERATE_REPORT_SUCCESS:
      return { ...state, loading: false, taskStatus: action.payload };
    case GENERATE_REPORT_FAILED:
      return { ...state, loading: false, taskStatus: action.payload };
    case GENERATE_REPORT_IN_PROGRESS:
      return { ...state, loading: false, taskStatus: action.payload };
    default:
      return state;
  }
};
